import { useState, useEffect } from 'react'
import { adminService } from 'core/services/adminService'
import { toast } from 'react-toastify'

import c from './assets/sass/marketing-edit.module.scss'

export const MarketingEdit = ({ campaignData, onSave, onCancel }) => {
    const [casesList, setCasesList] = useState([])
    const [usersCount, setUsersCount] = useState({
        all: 0,
        active7: 0,
        active14: 0,
        active30: 0,
    })
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        imageUrl: '/images/case-01.png',
        selectedCaseId: '',
        hint1: 'Пополни баланс — и бонус начислится автоматически',
        hint2: 'Чем больше депозит — тем выше твоя выгода',
        buttonText: 'ЗАБРАТЬ БОНУС',
        buttonUrl: 'https://ggstand.live/m/ggturbo',
        prizeType: 'promo-code',
        promoCodes: '',
        targetAll: false,
        targetActive7: false,
        targetActive14: false,
        targetActive30: false,
    })

    useEffect(() => {
        const loadCases = async () => {
            try {
                const data = await adminService.getMarketingCasesList()
                setCasesList(data.cases || [])
            } catch (error) {
                console.error('Failed to load cases:', error)
            }
        }
        loadCases()

        const loadUsersCount = async () => {
            try {
                const data = await adminService.getMarketingUsersCount()
                setUsersCount(
                    data.counts || {
                        all: 0,
                        active7: 0,
                        active14: 0,
                        active30: 0,
                    }
                )
            } catch (error) {
                console.error('Failed to load users count:', error)
            }
        }
        loadUsersCount()
    }, [])

    useEffect(() => {
        if (campaignData) {
            setFormData({
                title: campaignData.title,
                description: campaignData.description,
                imageUrl: campaignData.imageUrl || '/images/case-01.png',
                selectedCaseId: campaignData.caseId || '',
                hint1: campaignData.hint1 || '',
                hint2: campaignData.hint2 || '',
                buttonText: campaignData.buttonText || 'ЗАБРАТЬ БОНУС',
                buttonUrl:
                    campaignData.buttonUrl ||
                    'https://ggstand.live/m/ggturbo',
                prizeType: campaignData.prizeType || 'promo-code',
                promoCodes: campaignData.promoCodes?.join('\n') || '',
                targetAll: campaignData.targetAll,
                targetActive7: campaignData.targetActive7,
                targetActive14: campaignData.targetActive14,
                targetActive30: campaignData.targetActive30,
            })
        }
    }, [campaignData])

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!formData.title || !formData.description) {
            toast('Заполните обязательные поля', { type: 'warning' })
            return
        }

        if (formData.prizeType === 'case' && !formData.selectedCaseId) {
            toast('Выберите кейс из приложения', { type: 'warning' })
            return
        }

        if (
            !formData.targetAll &&
            !formData.targetActive7 &&
            !formData.targetActive14 &&
            !formData.targetActive30
        ) {
            toast('Выберите целевую аудиторию', { type: 'warning' })
            return
        }

        try {
            const codes = formData.promoCodes
                .split('\n')
                .map((c) => c.trim())
                .filter((c) => c.length > 0)

            const data = {
                title: formData.title,
                description: formData.description,
                imageUrl: formData.imageUrl,
                hint1: formData.hint1,
                hint2: formData.hint2,
                buttonText: formData.buttonText,
                buttonUrl: formData.buttonUrl,
                prizeType: formData.prizeType,
                promoCodes: codes,
                caseId:
                    formData.prizeType === 'case'
                        ? formData.selectedCaseId
                        : null,
                targetAll: formData.targetAll,
                targetActive7: formData.targetActive7,
                targetActive14: formData.targetActive14,
                targetActive30: formData.targetActive30,
            }

            if (campaignData) {
                await adminService.updateMarketingCampaign(
                    campaignData.id,
                    data
                )
                toast('Кампания обновлена', { type: 'success' })
            } else {
                await adminService.createMarketingCampaign(data)
                toast('Кампания создана', { type: 'success' })
            }

            onSave()
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        }
    }

    const prizeTypes = [
        {
            value: 'case',
            label: '🎁 Кейс из приложения (с автовыдачей промокода)',
        },
        { value: 'deposit-code', label: '💰 Промокод на депозит' },
        { value: 'promo-code', label: '🎟️ Промокод (общий)' },
        { value: 'skin-code', label: '🎨 Промокод на скин' },
        { value: 'wheel-code', label: '🎰 Промокод на вращение' },
        { value: 'xp-code', label: '⭐ Промокод на XP' },
        { value: 'balance-code', label: '💳 Промокод на баланс' },
        {
            value: 'deposit-free-case',
            label: '🎁💸 Бесплатный кейс при депозите',
        },
        { value: 'gift', label: '🎉 Суперприз / Чистый маркетинг' },
    ]

    return (
        <form className={c.component} onSubmit={handleSubmit}>
            <div className={c.field}>
                <label>Название *</label>
                <input
                    type="text"
                    value={formData.title || ''}
                    onChange={(e) =>
                        setFormData({ ...formData, title: e.target.value })
                    }
                    placeholder="Название кампании"
                />
            </div>

            <div className={c.field}>
                <label>Описание *</label>
                <textarea
                    value={formData.description || ''}
                    onChange={(e) =>
                        setFormData({
                            ...formData,
                            description: e.target.value,
                        })
                    }
                    placeholder="Описание кампании"
                    rows={3}
                />
            </div>

            <div className={c.field}>
                <label>Тип приза</label>
                <select
                    value={formData.prizeType}
                    onChange={(e) =>
                        setFormData({ ...formData, prizeType: e.target.value })
                    }
                >
                    {prizeTypes.map((pt) => (
                        <option key={pt.value} value={pt.value}>
                            {pt.label}
                        </option>
                    ))}
                </select>
            </div>

            {formData.prizeType === 'case' ? (
                <>
                    <div className={c.field}>
                        <label>
                            Выбрать кейс из приложения (для картинки и названия)
                            *
                        </label>
                        <select
                            value={formData.selectedCaseId}
                            onChange={(e) => {
                                const caseId = e.target.value
                                const selectedCase = casesList.find(
                                    (cs) => cs.id === caseId
                                )
                                setFormData({
                                    ...formData,
                                    selectedCaseId: caseId,
                                    imageUrl:
                                        selectedCase?.imageUrl ||
                                        '/images/case-01.png',
                                })
                            }}
                        >
                            <option value="">-- Выберите кейс --</option>
                            {casesList.map((cs) => (
                                <option key={cs.id} value={cs.id}>
                                    {cs.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className={c.field}>
                        <label>
                            Промокоды для рассылки (НЕ из магазина кейсов) *
                        </label>
                        <textarea
                            value={formData.promoCodes || ''}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    promoCodes: e.target.value,
                                })
                            }
                            placeholder="CASE_PROMO_MULTI (1 код на всех)&#10;&#10;Или:&#10;CODE1&#10;CODE2&#10;CODE3&#10;(по 1 коду на юзера)"
                            rows={5}
                        />
                        <small
                            style={{
                                color: 'rgba(255,255,255,0.5)',
                                fontSize: '12px',
                                marginTop: '4px',
                                display: 'block',
                            }}
                        >
                            • 1 промокод = всем юзерам одинаковый (настрой лимит
                            на сайте)
                            <br />• Несколько промокодов = каждому юзеру
                            случайный
                        </small>
                    </div>
                </>
            ) : (
                <>
                    <div className={c.field}>
                        <label>URL картинки</label>
                        <input
                            type="text"
                            value={formData.imageUrl || ''}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    imageUrl: e.target.value,
                                })
                            }
                            placeholder="/images/case-01.png"
                        />
                    </div>
                    <div className={c.field}>
                        <label>
                            Промокоды (опционально - для чистого маркетинга
                            оставьте пустым)
                        </label>
                        <textarea
                            value={formData.promoCodes}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    promoCodes: e.target.value,
                                })
                            }
                            placeholder="CODE1&#10;CODE2&#10;CODE3&#10;&#10;Оставьте пустым для модалки без промокода"
                            rows={5}
                        />
                    </div>
                </>
            )}

            <div className={c.field}>
                <label>Подсказка 1</label>
                <input
                    type="text"
                    value={formData.hint1 || ''}
                    onChange={(e) =>
                        setFormData({ ...formData, hint1: e.target.value })
                    }
                    placeholder="Пополни баланс — и бонус начислится автоматически"
                />
            </div>

            <div className={c.field}>
                <label>Подсказка 2</label>
                <input
                    type="text"
                    value={formData.hint2 || ''}
                    onChange={(e) =>
                        setFormData({ ...formData, hint2: e.target.value })
                    }
                    placeholder="Чем больше депозит — тем выше твоя выгода"
                />
            </div>

            <div className={c.field}>
                <label>Текст кнопки</label>
                <input
                    type="text"
                    value={formData.buttonText || ''}
                    onChange={(e) =>
                        setFormData({ ...formData, buttonText: e.target.value })
                    }
                    placeholder="ЗАБРАТЬ БОНУС"
                />
            </div>

            <div className={c.field}>
                <label>URL кнопки</label>
                <input
                    type="text"
                    value={formData.buttonUrl || ''}
                    onChange={(e) =>
                        setFormData({ ...formData, buttonUrl: e.target.value })
                    }
                    placeholder="https://ggstand.live/m/ggturbo"
                />
                <small
                    style={{
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: '12px',
                        marginTop: '4px',
                        display: 'block',
                    }}
                >
                    При наличии промокода он будет автоматически добавлен в
                    ссылку с UTM-метками (bonus_promo_code/promo_code/wheel_code
                    + utm_source=telegram_bot)
                </small>
            </div>

            <div className={c.targets}>
                <label>Целевая аудитория:</label>
                <div className={c.checkboxes}>
                    <label>
                        <input
                            type="checkbox"
                            checked={formData.targetAll}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    targetAll: e.target.checked,
                                })
                            }
                        />
                        <span>Все пользователи ({usersCount.all})</span>
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            checked={formData.targetActive7}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    targetActive7: e.target.checked,
                                })
                            }
                        />
                        <span>Активные за 7 дней ({usersCount.active7})</span>
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            checked={formData.targetActive14}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    targetActive14: e.target.checked,
                                })
                            }
                        />
                        <span>Активные за 14 дней ({usersCount.active14})</span>
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            checked={formData.targetActive30}
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    targetActive30: e.target.checked,
                                })
                            }
                        />
                        <span>Активные за 30 дней ({usersCount.active30})</span>
                    </label>
                </div>
                <div
                    style={{
                        marginTop: '12px',
                        padding: '8px',
                        background: 'rgba(255,211,89,0.1)',
                        borderRadius: '6px',
                    }}
                >
                    <p
                        style={{
                            fontSize: '13px',
                            color: 'rgba(255,255,255,0.7)',
                            margin: 0,
                        }}
                    >
                        {(() => {
                            let count = 0
                            if (formData.targetAll)
                                count = Math.max(count, usersCount.all)
                            if (formData.targetActive7)
                                count = Math.max(count, usersCount.active7)
                            if (formData.targetActive14)
                                count = Math.max(count, usersCount.active14)
                            if (formData.targetActive30)
                                count = Math.max(count, usersCount.active30)

                            const codes = formData.promoCodes
                                .split('\n')
                                .filter((c) => c.trim()).length

                            if (count === 0) return 'Выберите аудиторию'
                            if (formData.prizeType === 'case' || codes === 0)
                                return `Будет отправлено: ~${count} юзерам`
                            if (codes === 1)
                                return `Будет отправлено: ~${count} юзерам (1 промокод на всех)`
                            if (codes < count)
                                return `⚠️ Недостаточно промокодов! Нужно: ${count}, есть: ${codes}`
                            return `Будет отправлено: ~${count} юзерам (${codes} промокодов)`
                        })()}
                    </p>
                </div>
            </div>

            <div className={c.actions}>
                <button type="submit" className={c.saveBtn}>
                    {campaignData ? 'Сохранить' : 'Создать'}
                </button>
                <button
                    type="button"
                    onClick={onCancel}
                    className={c.cancelBtn}
                >
                    Отмена
                </button>
            </div>
        </form>
    )
}
